import axios from 'axios';
import authHeader from './auth-header';
import { DataAPi } from '../components/variable/dataVariable';

class UserService {
  getPublicContent() {
    return axios.get(DataAPi.urlTestApi + 'all');
  }

  getUserBoard() {
    return axios.get(DataAPi.urlTestApi + 'user', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(DataAPi.urlTestApi + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(DataAPi.urlTestApi + 'admin', { headers: authHeader() });
  }
}

export default new UserService();